import React, { forwardRef } from 'react'

import { type IconProp } from 'slab/types'
import { mergeRefs } from 'utils/ref_utils'

import { InputBlockField } from './Field'
import { type ColumnSpan } from './types'

export interface InputProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'className'> {
  error?: React.ReactNode;
  leadingIcon?: IconProp;
  label: React.ReactNode;
  placeholder?: string;
  span?: ColumnSpan;
  type?: 'text' | 'number' | 'email' | 'password' | 'tel' | 'date';
}

export const InputBlockInput = forwardRef<HTMLInputElement, InputProps>(
  ({ placeholder = '', type = 'text', ...props }, forwardedRef) => {
    return (
      <InputBlockField {...props}>
        {({ ref, ...fieldProps }) => (
          <input
            {...fieldProps}
            ref={mergeRefs(ref, forwardedRef)}
            placeholder={placeholder}
            type={type}
          />
        )}
      </InputBlockField>
    )
  }
)
